import styled from 'styled-components';

import Colors from '@rockalingua/ui/constants/Colors';

export const TabsContainer = styled.div`
  display: inline-flex;
  background-color: ${Colors.NEUTRAL_VARIANTS[20]};
  border: 1px solid ${Colors.NEUTRAL_VARIANTS[20]};
  border-radius: 12px;
  padding: 4px;
  gap: 0;
`;

export const Tab = styled.button<{ $active: boolean }>`
  background-color: ${({ $active }) =>
    $active ? Colors.WHITE : 'transparent'};
  border: none;
  border-radius: 10px;
  padding: 8px 16px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.15s ease;
  white-space: nowrap;
`;
